module.exports = __webpack_public_path__ + "img/portraits_05_V.f0083996.jpg";